import logger from 'debug';
import { verifyResponseStatus, requestBase } from '../helpers';

const apiBase = 'api/home';
const debug = logger('pricing:home-api');

const homeApi = {
	/**
	 * @typedef {Function} initialize - initializes SPA with content and other init data
	 * @returns {Object} initialization response
	 */
	initialize: () => {
		let request = Object.assign({}, requestBase, { method: 'GET' });

		return fetch(`${apiBase}`, request)
			.then(verifyResponseStatus)
			.then(response => response.json());
	}
}

const apiInstance = Object.freeze(homeApi);
export { apiInstance as HomeApi };